import { useLocation, useParams } from "react-router-dom";

const Invoice = () => {
    const { id } = useParams();
    const location = useLocation();
    const isEditMode = Boolean(id);

    return (
        <div className="hk-pg-wrapper">
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <header className="page-header">
                                <div>
                                    <div className="page-title">
                                        <h2 className="mb-0">Invoice</h2>
                                        </div>
                                </div>
                                <div className="page-options-wrap">

                                    <div className="v-separator d-lg-inline-block d-none"></div>


                                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                                        href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                                        data-bs-original-title="Collapse">
                                        <span className="btn-icon-wrap">
                                            <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                                            <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                                        </span>
                                    </a>
                                </div>
                            </header>
                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Invoice